import Vue from "vue";
import Vuex from "vuex";
import {
	Setitem,
	Getitem
} from "../utils/item.js";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		mews: null, // WebSocket实例
		online: false, // 我的连接状态
		otherline: '离线',
		Swindow: '', //打开的窗口是哪个
		newchat: {}, //新消息



		Islogin: null, //判断是否假登录完成
		menu: [], //项目类别
		username: Getitem("name"), //登录name
		log401: '', //是否401，是就直接等于401
		tokenName: '', //消息存储名称
		gochat: null,
		toid: '',
		porjecttype: {},
		ll: '',
		isonline: '',
		clist: false,
		msgs: {},
		prjectmenu: [],






		routerArr: {},
		// 新工单/未处理工单信息
		newWork: "",

		// 当前登录用户名
		// username: "",

		// 当前用户ID
		userid: "",

		// 用户真实姓名/昵称
		name: "",

		// 档案详细信息对象
		danganmingxi: {},

		// 项目明细信息对象
		xiangmumx: {},

		// 财务现金余额数据
		cash: [],

		// 未读消息数量
		msg: 0,

		// 通用数字类型状态（可根据业务需要扩展用途）
		number: 0,
	},

	getters: {}, // 未定义计算属性

	mutations: {
		//chat消息使用的
		setmews(state, e) {
			state.mews = e;
		},
		setonline(state, e) {
			state.online = e
		},
		setotherline(state, e) {
			state.otherline = e
		},
		setSwindow(state, e) {
			state.Swindow = e;
		},
		setnewchat(state, e) {
			state.newchat = e
		},








		setmenu(state, e) {
			state.menu = e;
		},
		setIslogin(state, e) {
			state.Islogin = e;
		},
		setusername(state, e) {
			state.username = e;
		},
		setlog401(state, e) {
			state.log401 = e
		},

		setTokenName(state, e) {
			state.tokenName = e
		},
		setgochat(state, e) {
			state.gochat = e
		},
		settoid(state, e) {
			state.toid = e
		},

		setporjecttype(state, e) {
			state.porjecttype = e
		},
		setll(state, e) {
			state.ll = e
		},
		setisonline(state, e) {
			state.isonline = e
		},

		setclist(state, e) {
			state.clist = e
		},
		setmsgs(state, e) {
			state.msgs = e
		},
		SETprjectmenu(state, e) {
			state.prjectmenu = e
		},









		setrouterArr(state, e) {
			state.routerArr = e;
		},
		/**
		 * 设置登录状态
		 * @param {Object} state - Vuex state
		 * @param {String} e - 用户名称
		 */
		login(state, e) {
			state.name = e;
		},

		/**
		 * 更新新工单状态
		 * @param {Object} state
		 * @param {String|Object} s - 新工单信息
		 */
		newobj(state, s) {
			state.newWork = s;
		},

		/**
		 * 更新用户显示名称
		 * @param {Object} state
		 * @param {String} e - 用户显示名称
		 */
		runName(state, e) {
			state.name = e;
		},

		/**
		 * 更新登录用户名
		 * @param {Object} state
		 * @param {String} e - 登录用户名
		 */
		cuser(state, e) {
			state.username = e;
		},

		/**
		 * 更新用户ID
		 * @param {Object} state
		 * @param {String|Number} e - 用户ID
		 */
		cusid(state, e) {
			state.userid = e;
		},

		/**
		 * 更新档案详细信息
		 * @param {Object} state
		 * @param {Object} e - 档案数据对象
		 */
		dangan(state, e) {
			state.danganmingxi = e;
		},

		/**
		 * 更新项目明细信息
		 * @param {Object} state
		 * @param {Object} e - 项目数据对象
		 */
		xmmx(state, e) {
			state.xiangmumx = e;
		},

		/**
		 * 更新财务现金数据
		 * @param {Object} state
		 * @param {Array} e - 现金余额数组
		 */
		balance(state, e) {
			state.cash = e;
		},

		/**
		 * 更新未读消息数量
		 * @param {Object} state
		 * @param {Number} e - 消息数量
		 */
		Dmegs(state, e) {
			state.msg = e;
		},

		/**
		 * 设置通用数字状态
		 * @param {Object} state
		 * @param {Number} e - 数字值
		 */
		setnumber(state, e) {
			state.number = e;
		},
	},

	actions: {
		/**
		 * 提交未接工单数量
		 * @param {Object} st - 包含commit方法的上下文对象
		 * @param {Number} e - 未接工单数
		 */
		weijiedan(st, e) {
			st.commit("newobj", e);
		},

		/**
		 * 提交用户显示名称
		 * @param {Object} state - 上下文对象
		 * @param {String} e - 用户显示名称
		 */
		runname(state, e) {
			state.commit("runName", e);
		},

		/**
		 * 提交登录用户名
		 * @param {Object} state
		 * @param {String} e - 登录用户名
		 */
		cusername(state, e) {
			state.commit("cuser", e);
		},

		/**
		 * 提交用户ID
		 * @param {Object} state
		 * @param {String|Number} e - 用户ID
		 */
		cuserid(state, e) {
			state.commit("cusid", e);
		},

		/**
		 * 提交档案信息转换结果
		 * @param {Object} state
		 * @param {Object} e - 档案数据对象
		 */
		bianhuan(state, e) {
			state.commit("dangan", e);
		},

		/**
		 * 提交项目明细信息
		 * @param {Object} state
		 * @param {Object} e - 项目数据对象
		 */
		xmMx(state, e) {
			state.commit("xmmx", e);
		},

		/**
		 * 提交财务现金数据
		 * @param {Object} state
		 * @param {Array} e - 现金数据数组
		 */
		Cash(state, e) {
			state.commit("balance", e);
		},

		/**
		 * 提交未读消息数量
		 * @param {Object} state
		 * @param {Number} e - 消息数量
		 */
		Dmsg(state, e) {
			state.commit("Dmegs", e);
		},
	},

	modules: {}, // 未使用模块化
});